<script lang="ts">
  import SettingsLayout from '../../components/SettingsLayout.svelte';
  import DataTablesManager from '../../components/DataTablesManager.svelte';
  import DataImportFlow from '../../components/DataImportFlow.svelte';
  import DedupRulesManager from '../../components/DedupRulesManager.svelte';

  type Sub = 'tables' | 'duplicates' | 'import';
  let {
    sub = 'tables',
    params,
  }: {
    sub?: Sub;
    params?: { slug?: string };
  } = $props();

  const focusSlug = $derived(params?.slug);
  const activeKey = $derived(
    sub === 'duplicates' ? 'data-duplicates' : sub === 'import' ? 'data-import' : 'data-tables',
  );
</script>

<SettingsLayout active={activeKey}>
  <div class="mx-auto max-w-[1200px]">
    {#if sub === 'tables'}
      <DataTablesManager focusSlug={focusSlug} />
    {:else if sub === 'duplicates'}
      <DedupRulesManager />
    {:else if sub === 'import'}
      <DataImportFlow focusSlug={focusSlug} />
    {/if}
  </div>
</SettingsLayout>
